import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.GENERAL]: {
    [ROLE.CONTAINER]: [ELEMENT.BREADCRUMB],
  },
} as TValidTestId;
